module.exports = __webpack_public_path__ + "static/media/Mobile_Data_DESIGN_SPRINT.7a025795.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/design_sprint/Mobile_Data_DESIGN_SPRINT.png
// module id = 76
// module chunks = 0